import React, { useState } from 'react';
import { Link } from 'react-router-dom';

const PortfolioGrid = ({ items, filters }) => {
  const [activeFilter, setActiveFilter] = useState('all');

  const filteredItems = items.filter((item) => {
    if (activeFilter === 'all') return true;
    return item.category === activeFilter;
  });

  return (
    <>
      {filters && filters.length > 0 && (
        <ul className="portfolio-filter">
          {filters.map((filter) => (
            <li key={filter.id}>
              <button
                onClick={() => setActiveFilter(filter.value)}
                className={activeFilter === filter.value ? 'active' : ''}
              >
                {filter.text}
              </button>
            </li>
          ))}
        </ul>
      )}

      <div className="grid grid-3">
        {filteredItems.map((item) => {
          // Fix image paths - remove ./ prefix to work with public folder
          const imageSrc = (item.portfolioImage || item.image).replace('./', '/');

          return (
            <Link to={`/portfolio/${item.id}`} key={item.id} className="card">
              <img
                src={imageSrc}
                alt={item.title}
                className="card-image"
                loading="lazy"
              />
              <div className="card-content">
                <h3 className="card-title">{item.title}</h3>
                <p className="card-text">{item.client}</p>
              </div>
            </Link>
          );
        })}
      </div>
    </>
  );
};

export default PortfolioGrid;
